/* src/app/components/move-to/move-to.component.scss */
.modal-header .modal-title {
  font-weight: 300;
  width: 70%;
}
.modal-header .title-name {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 400;
}
/*# sourceMappingURL=move-to.component.css.map */
